import { Trans } from "@lingui/macro"
import { Button, ButtonAsButtonProps } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import React from "react"
import { useIsTabletOrDesktop } from "../ResponsiveComponents"
import styles from "./SelectSuiteButton.module.scss"

interface SelectSuiteButtonAndContinueProps extends Partial<ButtonAsButtonProps> {
    selected: boolean
}

const SelectSuiteButtonAndContinue: React.FC<React.PropsWithChildren<SelectSuiteButtonAndContinueProps>> = ({
    children,
    selected,
    iconName,
    ...buttonProps
}) => {
    const isTabletOrDesktop = useIsTabletOrDesktop()

    const mainButtonProps: Partial<ButtonAsButtonProps> = selected
        ? {
              variant: "secondary",
              className: clsx(styles.isSelected, "cy-choose-suite-category-btn"),
          }
        : { variant: "primary", className: "cy-choose-suite-category-btn" }

    return (
        <Button
            renderAs="button"
            iconName={iconName}
            size={isTabletOrDesktop ? "regular" : "small"}
            dataContentPiece="suite-select-and-continue"
            {...mainButtonProps}
            {...buttonProps}
        >
            {selected ? <Trans>Continue</Trans> : <Trans>Choose and continue</Trans>}
            {children}
        </Button>
    )
}

export default SelectSuiteButtonAndContinue
